import "./style.css";

export function RadarSatText() {
  return (
    <div className="data_detail">
      <div className="detail">
        <span className="d_title_data"> RADARSAT-2</span>
        <span className="d_tag">分类：数据产品 &nbsp; 2017/09/26</span>
      </div>
      <div className="d_txt_data">
        <p>
          RADARSAT-2是一颗搭载C波段传感器高分辨率商用雷达卫星，由加拿大太空署与MDA公司合作，于2007年12月14日在哈萨克斯坦拜科努尔基地发射升空。
        </p>
        <p>
          RADARSAT-2具有1米高分辨率成像能力，多种极化方式使用户选择更为灵活，根据指令进行左右视切换获取图像缩短了卫星的重访周期，增加了立体数据的获取能力。另外，卫星具有强大的数据存储功能和高精度姿态测量及控制能力。
        </p>
        <p>&nbsp;　</p>
        <p>　&nbsp; &nbsp;(一)RADARSAT-2主要参数</p>
        <p>波段/频率：C波段/5.405GHz</p>
        <p>空间分辨率：1~100m</p>
        <p>重访周期：24天（完全参数）</p>
        <p>
          覆盖频率：1天（N70°以北）/1~2天（N48°以北）/2~3天（赤道）（最大幅宽）
        </p>
        <p>&nbsp;</p>
        <p>(二)产品模式</p>
        <p>RADARSAT-2有18种成像模式，分辨率从1-100m，幅宽18-500km。</p>
        <p>&nbsp;</p>
        <p>(三)基本特点和优势</p>
        <p>高分辨率模式：精细目标识别，信息最大化</p>
        <p>四极化模式：提高地物识别分类能力</p>
        <p>新增宽模式：新增五种宽幅模式，适用于大范围监测</p>
        <p>
          近实时编程：应急响应事件中，快速（4-12小时内）提供编程与影像获取服务
        </p>
        <p>近实时交付：数据接收后0.5-4小时内交付产品</p>
      </div>
    </div>
  );
}
